export default __webpack_public_path__ + "static/media/Logo.jobfirst.06873cfa.svg";